





























































































































import { HttpErrorHandler } from "@/mixins/error-handling";
import { DashboardHttp } from "@/mixins/http/dashboard";
import { BillingHttp } from "@/mixins/http/billing";
// eslint-disable-next-line no-unused-vars
import { DashboardCountsData } from "@/types/dashboard";
// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from "axios";
import { Component, Mixins } from "vue-property-decorator";
// eslint-disable-next-line no-unused-vars
import { User } from "@/types/user";
import DateUtils from "@/utils/dayjs";

@Component
export default class AccountSubscription extends Mixins(
	DashboardHttp,
	HttpErrorHandler,
	BillingHttp,
	DateUtils
) {
	countsData: DashboardCountsData = { numberOfDomains: 0, numberOfGroups: 0 };
	showRedirectDialog: boolean = false;
	TRIAL_LENGTH_DAYS: number = 15;
	TIMESTAMP_FACTOR = 1000;
	showErrorSnackbar = false;
	errorMessage = "";

	mounted() {
		this.getCountWidgetData()
			.then((response: AxiosResponse<any>) => {
				this.countsData = response.data;
			})
			.catch((error: any) => this.handleTokenExpired(error.response.data.message));
	}

	get planName(): string {
		let plan: string = (this.$store.getters["account/currentUser"] as User).subscription!.product!
			.name!;

		return plan;
	}

	async openBillingPortal() {
		try {
			this.showRedirectDialog = true;
			let response = await this.createBillingPortalSession(
				this.$store.getters["account/currentUser"].stripeCustomerId
			);
			let portalUrl: string = response.data.url;

			window.location.href = portalUrl;
		} catch (error) {
			this.showErrorSnackbar = true;
			this.errorMessage = "error";
		} finally {
			this.showRedirectDialog = false;
		}
	}

	get trialEndsInDays(): number {
		if (this.$store.getters["account/currentUser"].subscription.status == "trialing") {
			let trialStartedOn: Date = new Date(
				this.$store.getters["account/currentUser"].subscription.created * this.TIMESTAMP_FACTOR
			);
			let trialEndsOn: Date = this.addDays(trialStartedOn, this.TRIAL_LENGTH_DAYS);
			return this.calculateDaysLeft(trialEndsOn);
		} else {
			return 0;
		}
	}
}
